<template>
    <div class="table-canvas">

        <div class="class_box"
            v-for="(value,key,idx) in data"
            :key="idx"
            :title="key"
        >
            <div class="canvas_box" title="key"
                v-for="(v,k,i) in value"
                :key="i"
                :title="key +':'+ k"
                @click="click_dispatch($event,[key,k])"
            >
                <array-canvas :data="v"  :key="i">
                 
                 </array-canvas>
            </div>

            
        </div>

    </div>
</template>

<script>
 import ArrayCanvas from './com/ArrayCanvas.vue';
 import {map_trigger} from '~pjs/xfl_tool.esm.js';


export default ({
    name:'TableImg',
    props:{
        data:Object,
        size:Array,//如果data是一维的,size属性必须定义
        //data:Object,
        title:String,
        // size:Array,
 
    },
    data(){
        return {
            last_click:[],//上次单击
            last_click_cnt:0,//记录点击次数
            click_interval:600,//200ms内属于多次单击 1s内


        }
    },
    methods: {
        click_dispatch(evt,idx){
            let scope = this;
            console.log(evt);
            console.log(idx);
            if(scope.last_click[0] != idx[0] || scope.last_click[1] != idx[1]){
                //
                scope.last_click = idx;
                scope.last_click_cnt = 1;
                setTimeout(()=>{                  
                        scope.last_click = [];      
                        switch(scope.last_click_cnt){
                            case 1:{
                                console.log('single-click');
                                scope.$emit('click_pic',idx);
                                break;
                            };
                            case 2:{
                                console.log('db-click');
                                let map_list = [];
                                for(let j in scope.data[idx[0]]){
                                    map_list.push([idx[0],j]);
                                };
                                map_trigger(map_list,500,(v)=>{
                                    //console.log(v);
                                    scope.$emit('click_pic',v[1]);
                                    });
                                break;
                            };
                            default:{
                                console.log('tri-click');
                                let map_list = [];
                                for(let j in scope.data){
                                   for(let k in scope.data[j]){
                                       map_list.push([j,k])
                                   }
                                };
                                map_trigger(map_list,300,(v)=>{
                                    console.log(v);
                                    scope.$emit('click_pic',v[1]);
                                    });
                                break;
                            };
                 
                        }
                    },scope.click_interval)
            }else{
                scope.last_click_cnt++;

            }

        },
        is_object(v){
            return typeof(v)=='object' && !Array.isArray(v)
        }
    },
    computed:{

    },
    watch:{
        // table_canvas_array:{
        //     deep:true,
        //     handler(){
        //         console.log('table canvas watched data changed');
        //         console.log(this.data);
        //     }
        // }
    },
    components:{
        ArrayCanvas,
    }
})
</script>

<style lang="stylus" scoped>
.table-canvas
    color:white
    border:2px solid rgba(0,0,0.1,0.2);
    padding:5px 0px;
    display:inline-flex;
    
    overflow:show;
    
    &:hover
        &::-webkit-scrollbar
            height:8px;
            transition:height 1s ease-in-out;
            
    &::-webkit-scrollbar
        height:0px;
        //width:100px;
        background-color:rgba(255,255,255,1);
        transition:height 1s ease-in-out;

    &::-webkit-scrollbar-thumb
        border-radius: 10px;
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        background-color: #7fffAA;
    &::-webkit-scrollbar--track
        -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        border-radius: 10px;
        //background: #EDEDED;

.class_box
    display:flex;
    border:1px solid yellow 
    margin:0 2px;


.canvas_box

    border:1px solid transparent 
    margin:2px;

    &:hover
        border:1px solid green;

    & canvas
        min-width:20px;
        //min-height:30px;




</style>
